const DARK_BROWN = '#502314'

const neutral = {
    text: DARK_BROWN,
    transparentText: 'rgba(48, 49, 51, 30)',
    black40: 'rgba(0, 0, 0, 0.4)',
    chalk: '#F6F6F6',
    charcoal: '#3C3C3C',
    grey: '#666666',
    grey30: 'rgba(102,102,102,0.3)',
    darkGrey: '#1F1F1F',
    veryDarkGrey: '#131517',
    lightGrey: '#D8D8D8',
    veryLightGrey: '#F1F1F1',
    disabled: '#E9E9E9',
    lightGreyishOrange: '#F4EADA',
    lightOrange: '#FBF5ED',
    shadow: '#C8C8C8',
    shadowBox: 'rgba(48, 49, 51, 0.1)',
    dawnpink: '#E6D9CD',
    oceanBlue: '#54AAAB',
    greyBlue: '#4A4A52',
    delivery: '#00ccbc',
    lightWhite: 'rgba(216, 216, 216, 0.4)',
    transparent: 'rgba(0, 0, 0, 0)',
    veryLightWhite: 'rgba(255, 255, 255, 0.15)',
    offWhite: '#FDFDFD',
    black: '#000000'
}

const notification = {
    error: '#E2231A',
    success: '#4BAA00',
    warning: neutral.lightGreyishOrange
}

const primary = {
    red: '#BB1E32',
    red2: '#A11A2C',
    red3: '#E2231A',
    red4: '#B92136',
    red5: '#811522',
    red6: '#FFD4D4',
    red7: 'rgb(180, 30, 48)',
    red8: 'rgba(204, 0, 43, 0.08)',
    maroon: '#6F3C2F',
    orange: '#EE7700',
    orange2: '#F5A623',
    orange3: '#B75000',
    yellow: '#F7A800',
    yellow2: '#CF9600',
    yellow3: '#FBCC00',
    lightYellow: 'rgba(247, 168, 0, 0.4)',
    veryLightYellow: '#FFF5EC',
    pink: '#E37EAC'
}

const secondary = {
    tertiary: '#FBF5EE',
    tertiary2: '#F3E5D9',
    tertiary3: '#FFFEFE',
    lightMayo: '#FAF5ED',
    blue1: '#0071CE',
    blue2: '#94C0E9',
    blue3: '#0033A0',
    blue4: '#0D2F94',
    green1: '#4BAA00',
    green2: '#A4D55D',
    green3: '#68A919',
    richPurple1: '#A3007D',
    richPurple2: '#77226C',
    richPurple3: '#822589'
}

const social = {
    facebook: '#3D5C9A',
    google: '#D64036'
}

const branding = {
    bbqBrown: DARK_BROWN,
    crunchyGreen: '#198737',
    crunchyGreenDisabled: 'rgba(25, 135, 55, 0.4)',
    fieryRed: '#D62300',
    lightBrown: '#87604F',
    mayoEggWhite: '#F5EBDC',
    meltyYellow: '#FFAA00',
    flamingOrange: '#FF8732',
    white: '#FFFFFF'
}

const colors = {
    ...neutral,
    ...notification,
    ...primary,
    ...secondary,
    ...social,
    ...branding
}

export { colors }
